import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import GaiaLogo, { TYPE_WHITE } from '../GaiaLogo/GaiaLogo'

const DOT_COUNT = 24

function MosaicLoadingSplash ({ staticText }) {
  const t = (key) => staticText.getIn(['data', key], '')

  return (
    <div
      className="semantic-stitch-page__splash"
      role="status"
      aria-live="polite"
      aria-label={t('loadingHeading')}
    >
      <div className="semantic-stitch-page__splash-inner">
        <GaiaLogo
          type={TYPE_WHITE}
          className={['semantic-stitch-page__splash-logo']}
        />
        <span className="semantic-stitch-page__splash-mosaic">{t('mosaicBrandName')}</span>
        <div className="semantic-stitch-page__splash-divider" aria-hidden="true" />
        <p className="semantic-stitch-page__splash-heading">{t('loadingHeading')}</p>
        <p className="semantic-stitch-page__splash-subtext">{t('loadingSubtext')}</p>
        <div className="semantic-stitch-page__splash-spinner" aria-hidden="true">
          {Array.from({ length: DOT_COUNT }, (_, i) => (
            <span
              // eslint-disable-next-line react/no-array-index-key
              key={i}
              className="semantic-stitch-page__splash-dot"
              style={{
                '--dot-index': i,
                '--dot-count': DOT_COUNT,
              }}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

MosaicLoadingSplash.propTypes = {
  staticText: ImmutablePropTypes.map.isRequired,
}

export default MosaicLoadingSplash
